//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'user-info',
    props: {
      user: Object,
      default: {
          userName: "",
          ide: "",
          movePhone: "",
        },
    },
    data () {
      return {
        showDialog: false,
        userInfo: {
          userName: "",
          ide: "",
          movePhone: "",
        },

      }
    },
    created(){
      this.userInfo = this.user;
      //console.log('23123');
      //this.isRegister();
    },
    watch: {
      user (val) {
        this.userInfo = val;
      }
    },
    methods: {
      getImages (id) {
        return require(`@/assets/images/${id}.png`)
      },

    }
  }



// WEBPACK FOOTER //
// ./src/pages/userInfo.vue